var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.damages")))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c(
            "form",
            {
              attrs: {
                action: _vm.action,
                method: "POST",
                enctype: "multipart/form-data"
              }
            },
            [
              _c("input", {
                attrs: { type: "hidden", name: "_token", id: "csrf-token" },
                domProps: { value: _vm.token }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form-inline" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "button",
                    { staticClass: "btn-success", attrs: { type: "submit" } },
                    [
                      _c("i", { staticClass: "fa fa-file-excel-o" }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("message.importar")))])
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-xs-12" },
              [
                _c("k-table", {
                  ref: "listaReparaciones",
                  attrs: {
                    exportable: _vm.exportable,
                    mostrarTodos: false,
                    columns: _vm.columns,
                    path: _vm.path,
                    deleteButton: _vm.deleteButton && _vm.permiteEliminar,
                    createButton: _vm.permiteCrear,
                    editButton: _vm.editButton && _vm.permiteEditar
                  },
                  on: {
                    editar: _vm.editar,
                    eliminar: _vm.eliminar,
                    crear: _vm.crear
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            name: "reparacion",
            width: "60%",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("reparacion", {
            attrs: {
              damage: _vm.damage,
              reparation: _vm.reparation,
              title: _vm.title
            },
            on: { saved: _vm.saved, cancelar: _vm.cancelar },
            model: {
              value: _vm.selectedItem,
              callback: function($$v) {
                _vm.selectedItem = $$v
              },
              expression: "selectedItem"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-field" }, [
      _c("input", { attrs: { type: "file", name: "file", id: "file" } })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ae98e92", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ae98e92","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reparaciones/ListaReparaciones.vue
// module id = 322
// module chunks = 0